import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AllSolutionCards from "../AllSolutionCards";
import SolutionHeader from "./SolutionHeader";
import SimpleDrawer from "../../Atoms/Drawers/SimpleDrawer";
import UploadContent from "../../UploadDragger/UploadContent";
import { useSolution } from "../../../contexts/SolutionsContext";
import "../css/solution.dashboard.css";
import FooterSpacer from "../../Footer/FooterSpacer";
import SolVersionDropdown from "../SolutionDrawer/SolVersionDropdown";
import SolutionDetails from "../SolutionDrawer/SolutionDetails";
import { useDashboard } from "../../../contexts/DashboardContext";

const SolutionDashboard = () => {
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [statusVal, setStatusVal] = useState("");
  const [providerFilterVal, setProviderFilterVal] = useState("");
  const [industryFilterVal, setIndustryFilterVal] = useState("");
  const [sectorFilterVal, setSectorFilterVal] = useState("");

  const [functionFilterVal, setFunctionFilterVal] = useState([]);
  const {
    solutions,
    fetchSolutions,
    fetchSolutionsSilently,
    clearCurrentSolVersion,
    clearSelectedSol,
    clearSolVersions,
    clearOngoingSolutionData,
    fetchSolutionBFs,
    solutionDetailsDrawerOpen,
    changeSolutionDrawerState,
  } = useSolution();

  const { uploadDrawerOpen, changeUploadDrawerState } = useDashboard();

  // This is IMP - Clear ongoing solution data whenever location changes
  useEffect(() => {
    clearOngoingSolutionData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const getSolutionData = async () => {
      if (solutions && solutions?.length > 0) {
        fetchSolutionsSilently();
        fetchSolutionBFs();
      } else {
        await fetchSolutions();
      }
    };

    getSolutionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let filteredResults = solutions;

    // Search by title and description
    if (searchKey) {
      filteredResults = solutions?.filter(
        (solution) =>
          solution?.solution_name
            ?.toLowerCase()
            .includes(searchKey.toLowerCase()) ||
          solution?.solution_description
            ?.toLowerCase()
            .includes(searchKey.toLowerCase())
      );
    }

    // Filter by status
    if (statusVal && statusVal !== "All") {
      filteredResults = filteredResults?.filter(
        (solution) =>
          solution?.approval_status?.toLowerCase() === statusVal?.toLowerCase()
      );
    }

    // Filter by provider
    if (providerFilterVal && providerFilterVal !== "All") {
      filteredResults = filteredResults?.filter(
        (solution) =>
          solution?.solution_metadata?.a2a?.provider?.toLowerCase() === providerFilterVal?.toLowerCase()
      );
    }

    // Filter by industry
    if (industryFilterVal && industryFilterVal !== "All") {
      filteredResults = filteredResults?.filter((solution) => {
        const industryInfo = solution?.solution_metadata?.a2a?.industry_info;
        if (Array.isArray(industryInfo)) {
          return industryInfo.some(
            (info) =>
              info?.industry?.toLowerCase() === industryFilterVal?.toLowerCase()
          );
        }
        return (
          industryInfo?.industry?.toLowerCase() === industryFilterVal?.toLowerCase()
        );
      });
    }

    // Filter by sector
    if (sectorFilterVal && sectorFilterVal !== "All") {
      const lowercaseSector = sectorFilterVal.toLowerCase();
      filteredResults = filteredResults?.filter((solution) => {
        const industryInfo = solution?.solution_metadata?.a2a?.industry_info;

        if (Array.isArray(industryInfo)) {
          return industryInfo.some(info => {
            // Handle the case where info.sector is an array
            if (Array.isArray(info?.sector)) {
              return info.sector.some(sector =>
                sector.toLowerCase() === lowercaseSector
              );
            }
            // Fallback for string sector (if that ever exists)
            return typeof info?.sector === 'string' &&
              info.sector.toLowerCase() === lowercaseSector;
          });
        }

        // Fallback for non-array industry_info
        return false;
      });
    }


    // Filter by business function
    if (functionFilterVal && functionFilterVal.length > 0) {
      filteredResults = filteredResults?.filter((solution) => {
        // Check multiple possible locations for business function
        const businessFunction =
          solution?.business_function ||
          solution?.solution_metadata?.abusiness_function ||
          solution?.features?.business_function ||
          solution?.category ||
          solution?.function_category;

        if (businessFunction) {
          // Convert to string and check if any selected function matches
          const functionStr = String(businessFunction).toLowerCase();
          const matches = functionFilterVal.some(
            (selectedFunction) =>
              functionStr.includes(selectedFunction.toLowerCase()) ||
              selectedFunction.toLowerCase() === functionStr
          );
          return matches;
        }

        return false;
      });
    }

    // Update both searchResults and solutionData
    setSearchResults(filteredResults || []);
  }, [searchKey, statusVal, providerFilterVal, functionFilterVal, solutions, industryFilterVal, sectorFilterVal]);

  return (
    <>
      <div className="dashboard-sol">
        <main className="dashboard-main">
          <>
            <SolutionHeader
              setSearchKey={setSearchKey}
              setStatusVal={setStatusVal}
              setProviderFilterVal={setProviderFilterVal}
              setFunctionFilterVal={setFunctionFilterVal}
              setIndustryFilterVal={setIndustryFilterVal}
              setSectorFilterVal={setSectorFilterVal}
            />
            <div className="dashboard-content">
              <AllSolutionCards
                searchResults={searchResults}
                solutions={solutions}
              />
            </div>

            {/* Upload Drawer */}
            <SimpleDrawer
              drawerOpen={uploadDrawerOpen}
              setDrawerOpen={(open) => {
                changeUploadDrawerState(open);
                fetchSolutionsSilently();
                fetchSolutionBFs();
              }}
              placement={"right"}
              closable={false}
              width={"660px"}
              title={"Upload File"}
              padding={{ head: "16", body: "16" }}
              className="mcp-server-drawer"
              seperatorHeaderAndContent={false}
              Component={<UploadContent type={"solution"} />}
              clsNames="mas-agent-det-drawer"
            />

            {/* Solution Details Drawer */}
            <SimpleDrawer
              drawerOpen={solutionDetailsDrawerOpen}
              setDrawerOpen={(open) => {
                changeSolutionDrawerState(open);

                if (!open) {
                  clearSelectedSol();
                  clearSolVersions();
                  clearCurrentSolVersion();

                  fetchSolutionsSilently();
                  fetchSolutionBFs();
                }
              }}
              placement={"right"}
              closable={false}
              width={"660px"}
              title={<SolVersionDropdown />}
              padding={{ head: "16", body: "16" }}
              className="mcp-server-drawer"
              seperatorHeaderAndContent={false}
              Component={<SolutionDetails />}
              clsNames="mas-agent-det-drawer"
            />
          </>
        </main>

        <FooterSpacer />
      </div>
    </>
  );
};

export default SolutionDashboard;
